import { PlusOutlined } from "@ant-design/icons";
import Axios from "middleware/axiosInstance";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Button, Col, Form, Input, Modal, Row, Upload } from "antd";
import { getMediaUrl } from "config/env";
import { getBase64 } from "functions/functions";
import Loading from "layouts/Loading/Loading";
import OpenNotificationWithIcon from "layouts/notificationWithIcon/OpenNotificationWithIcon ";

const AddAndEditContent = () => {
  // start react router url params
  const UrlParams = useParams();
  const { contentId } = UrlParams;
  const isInEditMode = contentId ? true : false;
  // end react router url params
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const [content, setContent] = useState(null);
  const [contentInfoForEdit, setContentInfoForEdit] = useState(null);
  // upload image

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [fileList, setFileList] = useState([]);
  const handleCancel = () => setPreviewOpen(false);
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    );
  };
  const handleChange = ({ fileList: newFileList }) => setFileList(newFileList);
  const uploadButton = (
    <div>
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );

  // end of upload image

  const getContentWithId = (contentId) => {
    Axios.get(`/content/${contentId}`)
      .then((res) => {
        setContentInfoForEdit(res.data);
        if (res.data.image) {
          setFileList([{
            "thumbUrl": getMediaUrl(res.data.image)
            , "preview": getMediaUrl(res.data.image)
         
          }])
        }
        })
      .catch((err) => console.log(err));
  };

  const SubmitNewContent = async (content) => {
    if (fileList[0]) {
      const imageOfcontentInBase64 = await getBase64(fileList[0].originFileObj);
      content.image = imageOfcontentInBase64;
    }
    Axios.post("/content", content)
      .then((res) => {
        navigate("/contents");
        OpenNotificationWithIcon("ثبت موفق", "با موفقیت افزوده شد");
      })
      .catch((err) => console.log(err));
  };



  const contentEditHandler = async (content) => {
    if (fileList[0]) {
      if (fileList[0].originFileObj) {
        content.image = await getBase64(fileList[0].originFileObj)
      }
      else {
        delete content.image
      }
    }
    else {
      content.image = null
    }
    Axios.put(`/content/${contentId}`, content)
      .then((res) => {
        navigate("/contents");
        OpenNotificationWithIcon("ویرایش موفق", "با موفقیت ویرایش شد");
      })
      .catch((err) => console.log(err));
  }


  useEffect(() => {
    if (isInEditMode) {
      getContentWithId(contentId);
    }
  }, []);

  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <h5 className="title-session">افزودن محتویات غذا</h5>
        {isInEditMode && contentInfoForEdit === null ? (
          <Loading />
        ) : (
        

          <Form
            layout="vertical"
          
            initialValues={contentInfoForEdit}
           
            form={form}
            autoComplete="off"
            scrollToFirstError
            labelCol={{ xs: 24 }}
            onFinish={isInEditMode ? contentEditHandler : SubmitNewContent}
          >
            <Row gutter={8}>
              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item label="نام فارسی" name="contents_fa">
                  <Input placeholder="پیتزا" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item label="نام انگلیسی" name="contents_en">
                  <Input placeholder="Pizzza" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item label="نام عربی" name="contents_ar">
                  <Input placeholder="الپیتزا" />
                </Form.Item>
              </Col>

              <Upload
                listType="picture-card"
                fileList={fileList}
                onPreview={handlePreview}
                onChange={handleChange}
                beforeUpload={() => false}
                maxCount={1}
              >
                {fileList.length >= 1 ? null : uploadButton}
              </Upload>
              <Modal
                open={previewOpen}
                title={previewTitle}
                footer={null}
                onCancel={handleCancel}
              >
                <img
                  alt="example"
                  style={{
                    width: "100%",
                  }}
                  src={previewImage}
                />
              </Modal>
              <Button
                htmlType="submit"
                type="primary"
              >
                {isInEditMode ? "ثبت تغییرات" : "افزودن"}
              </Button>
            </Row>
          </Form>
        )}
      </div>
    </div>
  );
};

export default AddAndEditContent;
